import {useQuery} from '@tanstack/react-query';

import {GetSaoLucasBillsParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {makeGetSaoLucasBills} from 'main/factories/usecases';

type QueryParams = Omit<GetSaoLucasBillsParams, 'signal'>;

export const useGetSaoLucasBillsQuery = (enabled: boolean, params: QueryParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.SAO_LUCAS_BILLS, params],
		queryFn: async ({signal}) => {
			const response = await makeGetSaoLucasBills().get({...params, signal});
			return response?.data ?? [];
		},
		retry: 2,
		enabled,
	});
